import React, {createContext, FC, ReactNode, useContext} from 'react'

const ChannelSettingLinkedPanelLayoutContext = createContext(false)

/** True inside settings-child-panel / settings-mapping-child-panel when sequence layout is on. */
export const useChannelSettingLinkedPanelLayout = (): boolean =>
  useContext(ChannelSettingLinkedPanelLayoutContext)

type ProviderProps = {
  enabled: boolean
  children: ReactNode
}

export const ChannelSettingLinkedPanelLayoutProvider: FC<ProviderProps> = ({
  enabled,
  children,
}) => (
  <ChannelSettingLinkedPanelLayoutContext.Provider value={enabled}>
    {enabled ? (
      <div className='settings-linked-panel-layout-active'>{children}</div>
    ) : (
      children
    )}
  </ChannelSettingLinkedPanelLayoutContext.Provider>
)
